import React, { useEffect } from "react";
import { MapPin, Banknote, Users, PartyPopper, Rocket, User2 } from "lucide-react";
import { useTabContext } from "Common/Components/Tab/TabContext";
import { Nav } from "Common/Components/Tab/Nav";
import Tab from "Common/Components/Tab/Tab";
import CustomerForm from "./CustomerForm";
import AddressForm from "./AddressForm";

const CustomerModalContent = ({
    activeTab,
    setActiveTab,
    tabOrder,
    customerFormRef,
    addressFormRef,
    onResetTab,
    setCustomerId,
    customerId,
  }: {
    activeTab: string;
    setActiveTab: (tab: string) => void;
    tabOrder: string[];
    customerFormRef: React.RefObject<any>;
    addressFormRef: React.RefObject<any>;
    onResetTab?: (fn: () => void) => void;
    setCustomerId: (id: number) => void;
    customerId: number | null; 
  }) => {
    const { changeTab } = useTabContext();

    const goToNextTab = () => {
        const currentIndex = tabOrder.indexOf(activeTab);
        const nextTab = tabOrder[currentIndex + 1];
        if (nextTab) {
            setActiveTab(nextTab);
            changeTab(nextTab);
        }
    };

    useEffect(() => {
        if (onResetTab) {
          onResetTab(() => {
            setActiveTab("customerForm");
            changeTab("customerForm");
          });
        }
      }, [onResetTab, setActiveTab, changeTab]);

    return (
        <>
            <Nav className="grid grid-cols-1 gap-3 lg:grid-cols-6 nav-tabs form-wizard">
                <Nav.Item eventKey="customerForm" className="group/item">
                    <a href="#!" data-target="customerForm" data-tab-id="1" className="block px-4 py-5 text-center rounded-md text-slate-500 bg-slate-50 dark:text-zink-200 dark:bg-zink-600 group-[.active]/item:bg-custom-500 group-[.active]/item:text-custom-50">
                        <User2 className="block h-6 mx-auto fill-slate-200 dark:fill-zink-400 group-[.active]/item:fill-slate-200 dark:group-[.active]/item:fill-custom-500" />
                        <span className="block mt-3 font-medium text-15">1. Información Personal</span>
                    </a>
                </Nav.Item>
                <Nav.Item eventKey="addressInfo" className="group/item">
                    <a href="#!" data-target="addressInfo" data-tab-id="2" className="block px-4 py-5 text-center rounded-md text-slate-500 bg-slate-50 dark:text-zink-200 dark:bg-zink-600 group-[.active]/item:bg-custom-500 group-[.active]/item:text-custom-50">
                        <MapPin className="block h-6 mx-auto fill-slate-200 dark:fill-zink-400 group-[.active]/item:fill-slate-200 dark:group-[.active]/item:fill-custom-500" />
                        <span className="block mt-3 font-medium text-15">2. Dirección</span>
                    </a>
                </Nav.Item>
                <Nav.Item eventKey="personalInfo" className="group/item">
                    <a href="#!" data-target="personalInfo" data-tab-id="3" className="block px-4 py-5 text-center rounded-md text-slate-500 bg-slate-50 dark:text-zink-200 dark:bg-zink-600 group-[.active]/item:bg-custom-500 group-[.active]/item:text-custom-50">
                        <Rocket className="block h-6 mx-auto fill-slate-200 dark:fill-zink-400 group-[.active]/item:fill-slate-200 dark:group-[.active]/item:fill-custom-500" />
                        <span className="block mt-3 font-medium text-15">3. Teléfonos</span>
                    </a>
                </Nav.Item>
                <Nav.Item eventKey="referencesInfo" className="group/item">
                    <a href="#!" data-target="referencesInfo" data-tab-id="4" className="block px-4 py-5 text-center rounded-md text-slate-500 bg-slate-50 dark:text-zink-200 dark:bg-zink-600 group-[.active]/item:bg-custom-500 group-[.active]/item:text-custom-50">
                        <Users className="block h-6 mx-auto fill-slate-200 dark:fill-zink-400 group-[.active]/item:fill-slate-200 dark:group-[.active]/item:fill-custom-500" />
                        <span className="block mt-3 font-medium text-15">4. Referencias Personales</span>
                    </a>
                </Nav.Item>
                <Nav.Item eventKey="activityInfo" className="group/item">
                    <a href="#!" data-target="activityInfo" data-tab-id="5" className="block px-4 py-5 text-center rounded-md text-slate-500 bg-slate-50 dark:text-zink-200 dark:bg-zink-600 group-[.active]/item:bg-custom-500 group-[.active]/item:text-custom-50">
                        <Banknote className="block h-6 mx-auto fill-slate-200 dark:fill-zink-400 group-[.active]/item:fill-slate-200 dark:group-[.active]/item:fill-custom-500" />
                        <span className="block mt-3 font-medium text-15">5. Actividad Económica</span>
                    </a>
                </Nav.Item>
                <Nav.Item eventKey="completed" className="group/item">
                    <a href="#!" data-target="completed" data-tab-id="4" className="block px-4 py-5 text-center rounded-md text-slate-500 bg-slate-50 dark:text-zink-200 dark:bg-zink-600 group-[.active]/item:bg-custom-500 group-[.active]/item:text-custom-50">
                        <PartyPopper className="block h-6 mx-auto fill-slate-200 dark:fill-zink-400 group-[.active]/item:fill-slate-200 dark:group-[.active]/item:fill-custom-500" />
                        <span className="block mt-3 font-medium text-15">4. Completado</span>
                    </a>
                </Nav.Item>
            </Nav>

            <Tab.Content className="mt-5 tab-content">
                <Tab.Pane eventKey="customerForm">
                    <CustomerForm ref={customerFormRef} onSuccess={goToNextTab} setCustomerId={setCustomerId}/>
                </Tab.Pane>
                <Tab.Pane eventKey="addressInfo">
                    <AddressForm ref={addressFormRef} onSuccess={goToNextTab} customerId={customerId} />
                </Tab.Pane>
                <Tab.Pane eventKey="personalInfo">
                    <CustomerForm ref={customerFormRef} onSuccess={goToNextTab} setCustomerId={setCustomerId}/>
                </Tab.Pane>
                <Tab.Pane eventKey="referencesInfo">
                    <CustomerForm ref={customerFormRef} onSuccess={goToNextTab} setCustomerId={setCustomerId}/>
                </Tab.Pane>
                <Tab.Pane eventKey="activityInfo">
                    <CustomerForm ref={customerFormRef} onSuccess={goToNextTab} setCustomerId={setCustomerId}/>
                </Tab.Pane>
                <Tab.Pane eventKey="completed">
                    <CustomerForm ref={customerFormRef} onSuccess={goToNextTab} setCustomerId={setCustomerId}/>
                </Tab.Pane>
            </Tab.Content>
        </>
    );
};

export default CustomerModalContent;
